<template>
  <div>
  <el-upload 
    class="vedio-uploader"
    ref="upload"
    :disabled = "docUrl !=''"
    :accept='acceptExts'
    list-type="picture-card"
    :file-list="fileList"
    :show-file-list="false"
    :auto-upload="true"
    :data='access'
    :action='action'
    :limit="limit"
    :before-upload='beforeUpload'
    :on-remove="onRemoveHandler"
    :before-remove="onBeforeRemoveHandler"
    :on-progress='uploadVideoProcess'
    :on-success='onSuccessHandler'
    :on-error='onError'
    :on-exceed="onExceed">
    <video v-if="docUrl !='' && videoFlag == false" :src="docUrl" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
    <i v-else-if="docUrl =='' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
    <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:5px;"></el-progress>
  </el-upload>
  <el-button type="danger" icon="el-icon-delete" @click="clearFile" v-if="docUrl !='' && videoFlag == false" ></el-button>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import Newuploader from 'lib/mixins/Newuploader';

export default {
  name: 'oss-newthumbnail',
  mixins: [Newuploader],
  props: {
    fileInfo:{
      default: {}
    },
    files:{
      type: [Array,String],
      default: []
    },
  },
  data() {
    return {
      limit: 1,
      isNeedSave: 1, // 1 保存为封面、头像等不在课件中展示
      acceptExts: '.mp4',
      acceptTypes: ['video/mp4'],
      multiple: false,
      docId: '',
      docUrl: '',
      waitDeleteurl:'',
      videoFlag:false,
      videoUploadPercent:0,
      fileList:[]
    };
  },
  watch: {
  },
  created() {
    this.docId = this.fileInfo.docId;
    this.docUrl = this.fileInfo.docUrl;
  },
  beforeDestroy() {
    this.fileList = [];
  },
  methods: {
    clearFile(){
      this.docId = "";
      this.docUrl = "";
      this.fileList = [];
    },
    beforeUpload(file) {
      var that = this;
      let isPngJpg = this.acceptTypes.includes(file.type);
      if (!isPngJpg) {
        this.$message.info({
          title: file.name,
          message: '只能上传 mp4 格式的视频'
        });
        return false;
      }
      var fileData = file;

      return new Promise(resolve => {
        var reader = new FileReader();
        reader.onload = function (e) {
          that.addFile(file).then(resolve);
        };
        reader.readAsDataURL(fileData);
      });
    },
    uploadVideoProcess(event, file, fileList){
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    onExceed(files, fileList) {
      debugger;
      this.$message.warning(
        `本次选择了 ${files.length} 个文件，共选择了 ${files.length +fileList.length} 个文件, 超出单次最大上传文件 ${this.limit} 个的限制`
      );
    },
    onRemoveHandler(val) {
      if (this.onRemove) {
        this.onRemove();
      }
    },
    onBeforeRemoveHandler(file, fileList){
      this.waitDeleteurl = file.url;
    },
    onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        var audioElement = new Audio(res.docPath);
        var duration;
        audioElement.addEventListener("loadedmetadata", function (_event) {
          duration = audioElement.duration; //时长为秒，小数，182.36
          duration = parseInt(duration);
          var s = duration%60;
          var m = (duration-s)/60;
          var docTimeLenght = m +":"+s;


          that.videoFlag = false;
          that.videoUploadPercent = 0;
         
          that.docId = res.docId;
          that.docUrl = res.docPath;
          var file = {
            docId:res.docId,
            docUrl:res.docPath,
            docTitle:res.fileName,
            docTimeLenght: docTimeLenght
          };
          
          that.$emit('update:fileInfo',file);
        });
        file.url = res.docPath;
      }
    }
  }
};
</script>
<style lang="scss">
.vedio-uploader{
  .el-upload-list--picture-card{
      .el-upload-list__item{
          // width:200px;
          height: 140px;
      }
  }
  .thumbnail-uploader-icon{
      margin-top:0;
      font-size:40px;
  }
  .el-upload--picture-card{
      // width:200px;
      height: 140px;
  }
  .avatar{
    height: 100%;
    // width:200px;
    // height: 120px;
  }
}
</style>
